// extracted by mini-css-extract-plugin
module.exports = {"container":"Paper_container__xS2Ol"};